import React from "react";

interface SkillBarProps {
  skill: string;
  percentage: number;
  color?: "blue" | "green" | "red";
}

const SkillBar: React.FC<SkillBarProps> = ({ skill, percentage, color = "blue" }) => {
  const getColorClass = () => {
    switch (color) {
      case "green":
        return "bg-green-500";
      case "red":
        return "bg-red-500";
      default:
        return "bg-blue-500";
    }
  };

  return (
    <div className="mb-4">
      <div className="flex justify-between items-center mb-2">
        <span className="text-xs md:text-sm font-medium text-gray-700">{skill}</span>
        <span className="text-xs md:text-sm text-gray-500">{percentage}%</span>
      </div>
      <div className="w-full bg-gray-200 rounded-full h-1 md:h-2">
        <div
          className={`h-1 md:h-2 rounded-full ${getColorClass()}`}
          style={{ width: `${percentage}%` }}
        ></div>
      </div>
    </div>
  );
};

export default SkillBar;
